import * as yup from 'yup';

declare module 'yup' {
  interface Schema {
    /**
     * Rimuove il campo se il valore del campo `key` passato non è false, null, undefined
     */
    stripIfFalse(key: string): this;
  }
}

function registerForSchema<T extends yup.Schema>(schema: (...arg: any[]) => T) {
  yup.addMethod<T>(schema, 'stripIfFalse', function (this: T, key: string) {
    return this.when(key, ([flag]: any[], schema) => {
      return flag == null || flag === false ? schema.strip() : schema;
    });
  });
}

registerForSchema(yup.object);
registerForSchema(yup.array);
registerForSchema(yup.string);
registerForSchema(yup.number);
registerForSchema(yup.boolean);
registerForSchema(yup.date);
registerForSchema(yup.mixed);
